import React, { useState, useRef, useEffect } from "react";
import { FiEdit2, FiCheck, FiX } from "react-icons/fi";
import "./styles.scss";

const InlineEditableTitle = ({
  title,
  onSave,
  className = "",
  maxLength = 100,
  placeholder = "Enter title",
  disabled = false,
  extraContent = null,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(title);
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setValue(title);
  }, [title]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      setIsEditing(true);
    }
  };

  const handleSave = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    const trimmedValue = value.trim();

    if (!trimmedValue) {
      setValue(title);
      setIsEditing(false);
      return;
    }

    if (trimmedValue === title) {
      setIsEditing(false);
      return;
    }

    try {
      setIsLoading(true);
      await onSave(trimmedValue);
      setIsEditing(false);
    } catch (error) {
      setValue(title);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValue(title);
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave(e);
    } else if (e.key === "Escape") {
      handleCancel(e);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  if (isEditing) {
    return (
      <div className={`inline-editable-title-wrapper ${className}`}>
        <div className="inline-editable-title editing">
          <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onClick={handleInputClick}
            maxLength={maxLength}
            placeholder={placeholder}
            disabled={isLoading}
            className="inline-editable-input"
          />
          <div className="inline-editable-actions">
            <button
              type="button"
              onClick={handleSave}
              disabled={isLoading}
              className="inline-editable-btn save"
              title="Save"
            >
              <FiCheck />
            </button>
            <button
              type="button"
              onClick={handleCancel}
              disabled={isLoading}
              className="inline-editable-btn cancel"
              title="Cancel"
            >
              <FiX />
            </button>
          </div>
        </div>
        {extraContent && <div className="inline-editable-extra-content">{extraContent}</div>}
      </div>
    );
  }

  return (
    <div className={`inline-editable-title-wrapper ${className}`}>
      <div className="inline-editable-title-row">
        <div
          className={`inline-editable-title ${disabled ? "disabled" : ""}`}
          onClick={handleEditClick}
        >
          <span className="inline-editable-text">{title}</span>
          {!disabled && (
            <span className="inline-editable-icon">
              <FiEdit2 />
            </span>
          )}
        </div>
        {extraContent && <div className="inline-editable-extra-content-normal">{extraContent}</div>}
      </div>
    </div>
  );
};

export default InlineEditableTitle;
